module.exports = __webpack_public_path__ + "img/excellence3.70be613d.png";